import React from 'react';

import { Paper, TablePagination } from '@material-ui/core';
import { showErrorMessage, showLoader, showNoData } from 'screens/performanceReview/components/common';
import styled from 'styled-components';
import { FlexContainer, IconSizesCSS, StyledBox } from 'styles/common';

import { getColorFromKey } from 'constants/helper';
import theme from 'constants/theme';

import { TextHeader2 } from 'uiToolkitV1/Typography';

export const SectionHeader = ({ icon = null, title }) => (
  <HeaderContainer container alignItems="center">
    {icon && (
      <IconContainer size="header" color="textSecondary">
        {icon}
      </IconContainer>
    )}
    <TextHeader2 bold ml={3}>
      {title}
    </TextHeader2>
  </HeaderContainer>
);

const HeaderContainer = styled(FlexContainer)`
  align-items: center;
  padding: 1.5rem 1.5rem 1.25rem;
  border-bottom: 1px solid ${theme.palette.borders.lighterGrey};
  letter-spacing: 0.275px;
`;

const IconContainer = styled.div`
  display: flex;
  color: ${(props) => getColorFromKey(props.color)};

  svg {
    ${(props) => props.size && IconSizesCSS[props.size]};
    fill: ${(props) => getColorFromKey(props.color)};
  }
`;

const ChildWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: stretch;
  padding: 1.5rem 1.5rem;
  justify-content: center;
`;

const Divider = styled.div`
  border-bottom: 1px solid ${theme.palette.borders.lighterGrey};
  margin: 0 1.5rem;
`;

const ListTable = ({
  title,
  success,
  noDataMessage,
  error,
  loading,
  titleIcon: TitleIcon = null,
  paginationData,
  listData = [],
  searchHeader = null,
  headingHeader = null,
  // in case when complete list is sent as prop and table manages displaying part of it as per pagination
  managePagination = false,
  // adds a wrapper on row items with padding if this flag is OFF, else just renders row items
  decoratedRowItems = false,
  className = '',
}) => {
  const startIndex = paginationData.rowsPerPage * paginationData.currentPage;
  const endIndex = startIndex + paginationData.rowsPerPage;
  const rowsToDisplay = managePagination ? listData.slice(startIndex, endIndex) : listData;
  return (
    <StyledBox className={className} bottomGutter={4} width={1}>
      <Paper>
        {title && <SectionHeader icon={TitleIcon && <TitleIcon />} title={title} />}
        {searchHeader}
        {headingHeader}

        {loading
          ? showLoader()
          : error
            ? showErrorMessage({ errorText: error })
            : success && listData.length === 0
              ? showNoData({ infoText: noDataMessage })
              : rowsToDisplay.map(({ comp, id }, index) => (
                  <div key={id}>
                    {console.log('table data: ', comp)}
                    {decoratedRowItems ? comp : <ChildWrapper key={id}>{comp}</ChildWrapper>}
                    {index !== listData.length - 1 && <Divider />}
                  </div>
                ))}
        <StyledTablePagination
          component="div"
          count={paginationData.count || 0}
          rowsPerPage={paginationData.rowsPerPage || 0}
          rowsPerPageOptions={[]}
          page={paginationData.currentPage || 0}
          onChangePage={(e, newPage) => paginationData.setCurrentPage(newPage)}
          labelRowsPerPage={null}
        />
      </Paper>
    </StyledBox>
  );
};

const StyledTablePagination = styled(TablePagination)`
  padding: 0.5rem 1.5rem !important;
  border-top: 1px solid ${theme.palette.borders.lighterGrey};
`;

export default ListTable;
